import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Black_Submit_Btn from "../../common_btn/black_submit_btn/Black_Submit_Btn";
import "./Certification_Modal.css";

const Certification_Modal = ({ show, onHide, modalHeadingText, imgSrc, btnText }) => {
  return (
    <Modal
      className="common_modal Certification_Modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>
          <div className="back_div" onClick={() => onHide()}>
            <Common_Back_Btn />
          </div>
          {modalHeadingText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="cerificate_img_holder">
          <img
            src={process.env.PUBLIC_URL + imgSrc}
            className="certificate_img"
          />
        </div>

        <div className="btn_holder">
          <Black_Submit_Btn btnText={btnText} onClick={onHide} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Certification_Modal;
